import { useAuth } from '../contexts/AuthContext';

function Sidebar({ paginaAtiva, setPaginaAtiva }) {
  const { usuario, logout, podeVerAds, podeVerSocial, podeVerFinanceiro, isAdmin } = useAuth();

  const menu = [
    {
      id: 'home',
      label: 'Home',
      icon: '▦',
      sempre: true,
    },
    {
      categoria: 'Financeiro',
      acesso: podeVerFinanceiro,
      itens: [
        { id: 'financeiro', label: 'Receitas', icon: '↑' },
        { id: 'despesas', label: 'Despesas', icon: '↓' },
        { id: 'fluxo', label: 'Fluxo de Caixa', icon: '⇄' },
        { id: 'despesasfixas', label: 'Central de Despesas', icon: '≡' },
      ]
    },
    {
      categoria: 'Ads',
      acesso: podeVerAds,
      itens: [
        { id: 'ads', label: 'Dashboard', icon: '◈' },
        { id: 'ads_config', label: 'Configurações', icon: '⚙', acesso: isAdmin },
      ]
    },
    {
      categoria: 'Social Media',
      acesso: podeVerSocial,
      itens: [
        { id: 'social', label: 'Checklist', icon: '◎' },
      ]
    },
    {
      categoria: 'Agência',
      acesso: isAdmin,
      itens: [
        { id: 'clientes', label: 'Clientes', icon: '✦' },
        { id: 'crm', label: 'CRM', icon: '⊞' },
        { id: 'admin', label: 'Administração', icon: '⚙' },
      ]
    },
  ];

  const btnStyle = (id) => ({
    backgroundColor: paginaAtiva === id ? '#DCF127' : 'transparent',
    color: paginaAtiva === id ? '#0a0a0a' : '#666',
  });

  const handleHover = (e, id, enter) => {
    if (paginaAtiva === id) return;
    e.currentTarget.style.backgroundColor = enter ? '#1a1a1a' : 'transparent';
    e.currentTarget.style.color = enter ? '#fff' : '#666';
  };

  return (
    <div className="w-56 flex flex-col flex-shrink-0" style={{ backgroundColor: '#0a0a0a', borderRight: '1px solid #1a1a1a' }}>

      {/* Logo */}
      <div className="p-5" style={{ borderBottom: '1px solid #1a1a1a' }}>
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg flex items-center justify-center font-black text-xs flex-shrink-0"
            style={{ backgroundColor: '#DCF127', color: '#0a0a0a' }}>A</div>
          <div>
            <h1 className="text-white font-bold text-sm leading-none">Atris</h1>
            <p className="text-xs mt-0.5" style={{ color: '#555' }}>Performance Digital</p>
          </div>
        </div>
      </div>

      {/* Menu */}
      <nav className="flex-1 p-2 overflow-y-auto">

        {/* Home */}
        <button
          onClick={() => setPaginaAtiva('home')}
          className="w-full text-left px-3 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2.5 mb-1"
          style={btnStyle('home')}
          onMouseEnter={(e) => handleHover(e, 'home', true)}
          onMouseLeave={(e) => handleHover(e, 'home', false)}>
          <span className="text-sm">▦</span>
          Home
        </button>

        {/* Categorias */}
        {menu.filter(m => m.categoria && (m.acesso)).map((grupo) => (
          <div key={grupo.categoria} className="mb-1">
            <p className="px-3 py-1.5 text-xs font-semibold uppercase tracking-wider" style={{ color: '#333' }}>
              {grupo.categoria}
            </p>
            {grupo.itens
              .filter(item => item.acesso === undefined || item.acesso)
              .map(item => (
                <button
                  key={item.id}
                  onClick={() => setPaginaAtiva(item.id)}
                  className="w-full text-left px-3 py-2 rounded-lg text-sm font-medium transition-all flex items-center gap-2.5"
                  style={btnStyle(item.id)}
                  onMouseEnter={(e) => handleHover(e, item.id, true)}
                  onMouseLeave={(e) => handleHover(e, item.id, false)}>
                  <span className="text-sm">{item.icon}</span>
                  {item.label}
                </button>
              ))}
          </div>
        ))}
      </nav>

      {/* Usuário + Logout */}
      <div className="p-2" style={{ borderTop: '1px solid #1a1a1a' }}>
        {usuario && (
          <div className="px-3 py-2 mb-1">
            <p className="text-xs font-medium text-white">{usuario.nome}</p>
            <p className="text-xs" style={{ color: '#555' }}>{usuario.role}</p>
          </div>
        )}
        <button
          onClick={logout}
          className="w-full text-left px-3 py-2 rounded-lg text-sm font-medium transition-all"
          style={{ color: '#555' }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#1a1a1a'; e.currentTarget.style.color = '#ef4444'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#555'; }}>
          Sair
        </button>
      </div>
    </div>
  );
}

export default Sidebar;